module.exports = __webpack_public_path__ + "img/shop_3.e9b91083.png";